<template>
    <div class="echarts-line-wrapper" :style="{ height: height + 'px' }">
        <v-chart :options="chartOptions" autoresize ref="chart" />
    </div>
</template>
<script>
export default {
    name: "EChartsLine",
    props: {
        labels: { type: Array, default: () => [] },
        datasets: { type: Array, default: () => [] },
        options: { type: Object, default: () => ({}) },
        height: { type: Number, default: 300 },
    },
    computed: {
        chartOptions() {
            const series = this.datasets.map((ds) => {
                const areaStyle = ds.fill
                    ? {
                          color: ds.backgroundColor || "rgba(59, 130, 246, 0.12)",
                      }
                    : undefined;
                return {
                    name: ds.label || "",
                    type: "line",
                    data: ds.data || [],
                    smooth: ds.tension ? ds.tension >= 0.3 : false,
                    showSymbol: ds.pointRadius !== 0,
                    symbolSize: ds.pointRadius || 4,
                    lineStyle: {
                        width: ds.borderWidth || 2,
                        color: ds.borderColor || "#3b82f6",
                    },
                    itemStyle: {
                        color: ds.pointBackgroundColor || ds.borderColor || "#3b82f6",
                    },
                    areaStyle,
                };
            });

            return {
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0,0,0,0.8)",
                    textStyle: { color: "#fff", fontSize: 12 },
                    padding: 12,
                    borderRadius: 8,
                },
                legend: {
                    top: 0,
                    textStyle: { fontSize: 12 },
                    data: this.datasets.map((ds) => ds.label || ""),
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: this.labels,
                    axisLine: { lineStyle: { color: "#e5e7eb" } },
                    axisLabel: { fontSize: 11, color: "#6b7280" },
                },
                yAxis: {
                    type: "value",
                    axisLine: { show: false },
                    splitLine: { lineStyle: { color: "rgba(0,0,0,0.06)" } },
                    axisLabel: { fontSize: 11, color: "#6b7280" },
                },
                series,
                ...this.options,
            };
        },
    },
};
</script>
<style scoped>
.echarts-line-wrapper {
    position: relative;
    width: 100%;
}
.echarts-line-wrapper .echarts {
    width: 100% !important;
    height: 100% !important;
}
</style>
